// import flickity from '../flickity.pkgd.min.js'

// import smoothscroll from 'smoothscroll-polyfill';
export default {
  init() {
    // smoothscroll.polyfill();
    lazyLoad();
    activeAnchorGroup('')
    let tabs = document.getElementById('tabs');
    let filters = []
    window.onscroll = function() {
      lazyLoad();
    }
    window.onresize = function() {
      closeMenu()
      lazyLoad()
      resizePage()
    };

    // [].forEach.call(document.querySelectorAll('a.scrolldown'), function(el) { 
    //   el.preventDefault;
    //   el.addEventListener('click', function(){
    //     let nextSection = el.parentNode.nextSibling
    //     if(typeof(nextSection) != 'undefined' && nextSection.nextElementSibling != null){
    //       let oTop = nextSection.nextElementSibling.offsetTop
    //       window.scroll({
    //         top: oTop, 
    //         behavior: 'smooth',
    //       });
    //     }
    //   })
    // });
    // var sfEls = document.querySelectorAll('#menu-mainmenu li.menu-item-has-children');
    // for (var i=0; i<sfEls.length; i++) {
    //     sfEls[i].onmouseover=function() {
    //             this.className+=' mhover';
    //     }
    //     sfEls[i].onmouseout=function() {
    //             this.className=this.className.replace(new RegExp(' mhover\\b'), '');
    //     }
    // }
    // [].forEach.call(document.querySelectorAll('ul#menu-mainmenu > li'), function(el){
    //   el.addEventListener('mouseover', function(){
    //     setTimeout(() =>{
    //       this.classList.add('mhover')
    //       console.log('entry')

    //     },150)
    //   })
    // });
    // [].forEach.call(document.querySelectorAll('ul#menu-mainmenu > li'), function(el){
    //   el.addEventListener('mouseout', function(){
    //     this.classList.remove('mhover')
    //     console.log('leave')
    //   },150)
    // });

    let maskSVG = document.querySelectorAll('svg path')
    if(maskSVG !== null){
      [].forEach.call(maskSVG, function(path){
        path.addEventListener('click', function(){
          [].forEach.call(maskSVG, function(mask){
            mask.classList.remove('clicked')
          })
          this.classList.add('clicked')
          let entry = this.dataset.element
          if(typeof(entry) != 'undefined'){
            let eltList = document.querySelector('.list--offres li[data-entry="'+entry+'"]')
            if(eltList !== null){
              let info = eltList.querySelector('p')
              let infoContent = info.innerHTML
              let offreInfo = document.getElementById('offre-content').querySelector('p')
              
              if(offreInfo.innerHTML != ''){
                offreInfo.parentNode.classList.add('scaledown') 
                setTimeout(function(){
                  offreInfo.innerHTML = infoContent;  
                  offreInfo.parentNode.classList.remove('scaledown') 
                },550)
              }else{
                offreInfo.innerHTML = infoContent;  
              }
            }
          }
        }, {passive: true})
      })
    }

    let catOffre = document.querySelectorAll('.list--offres li span')
    if(catOffre !== null){
      [].forEach.call(catOffre, function(cat){
        cat.addEventListener('click', function(){
          if(this.parentNode.classList.contains('open'))
            this.parentNode.classList.remove('open')
          else
            this.parentNode.classList.add('open')
        })
      })
    }


    let bgmenu = document.getElementById('bgmenu')

    if(bgmenu !== null){
      let lastLi = document.createElement('li')
      let bgpict = document.createElement('img')
      bgpict.setAttribute('src',window.baseurl+'wp-content/themes/default-bd/dist/images/menu-rings.png')
      lastLi.classList.add('last-li')
      lastLi.appendChild(bgpict)
      bgmenu.querySelector('ul.nav').appendChild(lastLi)
      let pictosmenu = bgmenu.querySelectorAll('ul.sub-menu a img')
      if(pictosmenu !== null){
        pictosmenu.forEach(function(image){
          let pictoblue = image.dataset.blue
          image.setAttribute('src',pictoblue)
          image.classList.add('mm')
        })
      }
    }

    [].forEach.call(document.querySelectorAll('nav.nav-primary ul li a'), function(el){
      el.addEventListener('mouseover', function(){
        let picto = this.querySelector('img')
        if(picto !== null && !picto.classList.contains('mm')){
          let pictoHover = picto.dataset.white
          picto.setAttribute('src', pictoHover)
        }
      }, {passive: true})
      el.addEventListener('mouseout', function(){
        let picto = this.querySelector('img')
        if(picto !== null && !picto.classList.contains('mm')){
          let pictoOut = picto.dataset.default
          picto.setAttribute('src', pictoOut)
        }
      }, {passive: true})
    });

    [].forEach.call(document.querySelectorAll('nav.nav-primary ul.nav li'), function(el){
      if(el.classList.contains('with--visuel')){
        let submenu = el.querySelector('ul.sub-menu')
        let divVisuel = document.createElement('div')
        divVisuel.classList.add('visuel--menu')
        let picture = el.querySelector('a > span')
        if(picture !== null){
          picture = picture.dataset.visuel
          let elementVisuel = document.createElement('img')
          elementVisuel.setAttribute('src', picture)
          divVisuel.appendChild(elementVisuel)
          submenu.appendChild(divVisuel)

        }
      }
    });

    [].forEach.call(document.querySelectorAll('a.play--video'), function(el){
      el.addEventListener('click', function(){
        loadVideo(this.dataset.video)
      }, {passive: true})
    });

    [].forEach.call(document.querySelectorAll('.team .member'), function(el){
      el.addEventListener('click', function(){
        loadPortrait(this)
      }, {passive: true})
    });

    [].forEach.call(document.querySelectorAll('#bgmenu li.menu-item-has-children a'), function(el){
      el.addEventListener('click', function(){
        [].forEach.call(document.querySelectorAll('#bgmenu li.menu-item-has-children a'), function(element){
          element.parentNode.classList.remove('open-submenu')
        })
        this.parentNode.classList.add('open-submenu')
      }, {passive: true})
    });
    
    [].forEach.call(document.querySelectorAll('.accordion h4'), function(el){
      el.addEventListener('click', function(){
        this.classList.toggle('open')
      }, {passive: true})
    });

    [].forEach.call(document.querySelectorAll('a.scrolldown'), function(el) { 
      el.preventDefault;
      let nextSection = el.parentNode.nextSibling
      if(typeof(nextSection) != 'undefined' && nextSection.nextElementSibling != null){
        el.addEventListener('click', function(){
          SmoothVerticalScrollingForSafari(nextSection.nextElementSibling.offsetTop + 34, 500)
          // let oTop = window.innerHeight - 66;//nextSection.nextElementSibling.offsetTop
          // console.log(oTop)
          // window.scroll({
          //   top: oTop, 
          //   behavior: 'smooth',
          // });
        }, {passive: true})
      }else{
        el.remove()
      }
    });

    [].forEach.call(document.querySelectorAll('.cat_form input[type="checkbox"]'), function(el) { 
        el.addEventListener('change', function(){
          if(this.checked === true){
            filters.push(this.value)
          }else{
            let pool = filters.indexOf(this.value)
            filters.splice(pool, 1);
          }
          if(filters.length > 0){
            window.location.hash = filters.join(',')
          }else{
            history.replaceState({}, document.title, window.location.href.split('#')[0])
          }
          reloadFormations(filters)
        }, {passive: true})
    });

    [].forEach.call(document.querySelectorAll('span.field:not(.check)'), function(el) { 
        el.addEventListener('keyup', function(){
          this.classList.remove('error')
          if(this.querySelector('input').value != ''){
            this.querySelector('em').innerHTML = this.querySelector('input').getAttribute('placeholder')
          }else{
            this.querySelector('em').innerHTML = ''
          }
        }, {passive: true})
    });
    let btnEform = document.getElementById('sendeform')
    if(btnEform != null){
      btnEform.addEventListener('click',function(){
        sendEbookForm();
      }, {passive: true});
      let rgpdebook = document.getElementById('__acceptcond')
      rgpdebook.addEventListener('change',function(){
        if(this.checked === true)
          this.offsetParent.classList.remove('error')
        else
          this.offsetParent.classList.add('error')
      }, {passive: true});
    }

    document.addEventListener( 'click', listenerLive );

    let progressBar = document.querySelectorAll('.progress-bar')
    if(progressBar !== null && progressBar.length > 0){

      [].forEach.call(progressBar, function(el){
        let step = el.offsetParent.querySelectorAll('.nav-quiz input[type="hidden"]');
        [].forEach.call(step,function(s){
          s.value = 1
        });
  
        let bar = el.querySelector('p:nth-of-type(1)')
        let cStep = bar.dataset.current
        let nbSteps = bar.dataset.last
        let percent = cStep / nbSteps * 100
        let pbar = bar.querySelector('span')
        percent = 0
        pbar.setAttribute('style', 'width : '+percent+'%')
      })

      let iRadio = document.querySelectorAll('.quiz input[type="radio"]');
      [].forEach.call(iRadio, function(e){
        e.addEventListener('change',function(){
          let question = this.closest('div')
          let answers = question.querySelectorAll('p');
          [].forEach.call(answers, function(a){
            a.classList.remove('checked')
          })
          if(this.checked === true){
            this.parentNode.classList.add('checked')
            let next = this.closest('.quiz').querySelector('.nav-quiz .a--next')
            next.classList.remove('disable')
          }
          else
            this.parentNode.classList.remove('checked')
        }, {passive: true});
      })
    }
    let quizNext = document.querySelectorAll('.nav-quiz .next')
    if(quizNext !== null && quizNext.length > 0){
      [].forEach.call(quizNext, function(e){
        e.addEventListener('click',function(){
          if(this.parentNode.classList.contains('disable')){
            return false
          }else{
            let step = this.offsetParent.querySelector('.nav-quiz input[type="hidden"]')
            let curstep = step.value * 1
            let currentAnswer = document.querySelector('input[name="a_'+curstep+'[]"]:checked').value;
            if(currentAnswer == 1){
              var popinMessage = this.closest('.quiz-slider').querySelector('li.current div.popin.bad')
            }else{
              popinMessage = this.closest('.quiz-slider').querySelector('li.current div.popin')
            }
            if(popinMessage !== null){
              let blockMessage = this.closest('.quiz').querySelector('.thequiz')
              blockMessage.classList.add('show--message')
              blockMessage.querySelector('.step-message').innerHTML = popinMessage.innerHTML
              popinMessage.remove()
              this.parentNode.classList.add('disable')
            }else{
              let step = this.offsetParent.querySelector('.nav-quiz input[type="hidden"]')
              let curstep = step.value * 1
              let slideQuiz = this.offsetParent.querySelector('ul.questions')
              let transform = 100 * curstep * -1
              slideQuiz.setAttribute('style', 'transform: translateX('+transform+'%)')
              let curslide = slideQuiz.querySelector('li:nth-child('+curstep+')')
              curslide.setAttribute('style', 'opacity: 0')
      
              curslide.classList.remove('current')
              let nextslide = slideQuiz.querySelector('li:nth-child('+(curstep + 1)+')')
              nextslide.setAttribute('style', 'opacity: 1')
              nextslide.classList.add('current')
              curstep++
              let stepreached = this.dataset.stepreached
              console.log(curstep+' '+stepreached)
              if(curstep >= stepreached){
                this.parentNode.classList.add('disable')
              }
              changeQuizStep(this,curstep);
      
              step.value = curstep
              let quiz = this.offsetParent.querySelector('.quiz-slider')
              if(quiz !== null){
                quiz.dataset.curstep = curstep
              }
            }
          }
        })

      })
    }
    let quizPrev = document.querySelectorAll('.nav-quiz .prev')
    if(quizPrev !== null && quizPrev.length > 0){
      [].forEach.call(quizPrev, function(e){
        e.addEventListener('click',function(){
            let slideQuiz = this.offsetParent.querySelector('ul.questions')
            let step = this.offsetParent.querySelector('.nav-quiz input[type="hidden"]')
            let curstep = step.value * 1
            let curslide = slideQuiz.querySelector('li:nth-child('+curstep+')')
            curslide.setAttribute('style', 'opacity: 0')
            curslide.classList.remove('current')

            let prevslide = slideQuiz.querySelector('li:nth-child('+(curstep - 1)+')')
            prevslide.setAttribute('style', 'opacity: 1')
            prevslide.classList.add('current')

            curstep--;
            changeQuizStep(this,curstep);
            let transform = 100 * (curstep - 1) * -1
            slideQuiz.setAttribute('style', 'transform: translateX('+transform+'%)')
            step.value = curstep
            let quiz = this.offsetParent.querySelector('.quiz-slider')
            quiz.dataset.curstep = curstep
            this.closest('.buttons').nextElementSibling.classList.remove('disable')

        })
      })
    }

    let contactForm = document.querySelectorAll('.contact--form')
    if(contactForm !== null && contactForm.length > 0){
      contactForm = contactForm[0]
      let inputs  = contactForm.querySelectorAll('input[type="text"], textarea')
      if(inputs != null && inputs.length > 0){
        [].forEach.call(inputs, function(el){
          let e = el.getAttribute('placeholder')
          el.addEventListener('keypress', function(){
            this.offsetParent.classList.remove('error')
            this.nextElementSibling.innerHTML = e
            let answer = document.getElementById('answer')
            answer.classList.remove('visible')
          }, {passive: true})
          el.addEventListener('keyup', function(){
            if(this.value == '')
              this.nextElementSibling.innerHTML = ''
          }, {passive: true})
          if(el.value != ''){
            el.nextElementSibling.innerHTML = e
          }else{
            el.nextElementSibling.innerHTML = ''
          }
        })
      }
      let rgpd = document.getElementById('acceptcond')
      rgpd.addEventListener('change',function(){
        if(this.checked === true)
          this.offsetParent.classList.remove('error')
        else
          this.offsetParent.classList.add('error')
      }, {passive: true})
      let btnContact = document.getElementById('sendcontactform')
      btnContact.addEventListener('click',function(){
        sendForm();
      }, {passive: true})
    }











    window.addEventListener('hashchange', function(){
      // let tabs = document.getElementById('tabs'); 
      if(tabs == null){
        let getHash = window.location.hash.substring(1);
        // console.log(getHash)
        if(getHash.indexOf('_') == -1)
        {
          let header = document.querySelectorAll('header.banner')
          let hHeader =  header[0].offsetHeight

          let section = document.querySelectorAll('[data-anchor="'+getHash+'"]')
          if(section.length > 0)
          {
            activeAnchorGroup(getHash);
            let oTop = section[0].offsetTop
            oTop -= hHeader
            window.scroll({
              top: oTop, 
              behavior: 'smooth',
            });
          }
        }
      }
    }, {passive: true})
    if(typeof(tabs) != 'undefined' && tabs != null)
    {
      let selectOnglet = document.getElementById('select--onglet')
      /** tab navigation with menu select */
      selectOnglet.addEventListener('change', function() {
        let slug = this.selectedOptions[0].getAttribute('data-name')
        window.location.hash = '#'+slug
        let indexTab = this.value
        let tab = document.getElementById('tab_'+indexTab);
        let oTop = tabs.offsetTop
        window.scroll({
          top: oTop, 
          behavior: 'smooth',
        });
        [].forEach.call(document.querySelectorAll('.nav--tab .left--column a'), function(el) {
          el.classList.remove('active')
        });
        [].forEach.call(document.querySelectorAll('.nav--tab .right--column .tab'), function(el) {
          el.classList.remove('active')
        })
        document.querySelectorAll('.onglet_'+indexTab)[0].classList.add('active')
        tab.classList.add('active')
      }, {passive: true})

      /** tab navigation */
      if(window.location.hash) 
      {
        setTimeout(function(){
          let oTop = tabs.offsetTop

          window.scroll({
            top: oTop, 
            behavior: 'smooth',
          });
        },500)
        let getHash = window.location.hash.substring(1);
        activeCurrentTab(getHash, false);     
      }
    }else if(window.location.hash) 
    {
      let getHash = window.location.hash.substring(1);

      let listing = document.querySelector('.all--formations')
      if(listing != null){
        filters = getHash.split(',');
        [].forEach.call(document.querySelectorAll('.cat_form input[type="checkbox"]'), function(el) { 
            if(filters.indexOf(el.value) != -1){
              el.setAttribute('checked', true)
            }
        });
  
        reloadFormations(filters)
      }

      activeAnchorGroup(getHash)
      if(getHash.indexOf('_') == 0)
      {
        setTimeout(function(){
          let target = document.getElementById(getHash.substring(1));
          let oTop = target.offsetTop
          window.scroll({
            top: oTop, 
            behavior: 'smooth',
          });
        },750)
      }else{
        let section = document.querySelectorAll('section[data-anchor="'+getHash+'"]')
        if(section.length > 0)
        {
          setTimeout(function(){
            let oTop = section[0].offsetTop
            window.scroll({
              top: oTop, 
              behavior: 'smooth',
            });
          },500)
        }
      }
    }
      /** tab navigation */
      [].forEach.call(document.querySelectorAll('.nav--tab .left--column a'), function(el) { 
        el.addEventListener('click', function(){
          activeCurrentTab(this.dataset.slug, true)
        }, {passive: true})
      });
      /** tab navigation from sub-menu */
      [].forEach.call(document.querySelectorAll('.current-menu-ancestor .sub-menu li a'), function(el) {
        el.addEventListener('click', function(){
          let href = el.getAttribute('href').split('#')
          activeCurrentTab(href[1], true);
          closeMenu()
        }, {passive: true}) 
      });
      /** accordion interview content */
      [].forEach.call(document.querySelectorAll('.entretien li.qst'), function(el) {
        el.addEventListener('click', function() {
          // let oTop =this.offsetTop;
          // window.scroll({
          //   top: oTop, 
          //   behavior: 'smooth',
          // });
          el.parentNode.classList.toggle('active');
        }, {passive: true})
      });
      /** Anchors navigation */
      [].forEach.call(document.querySelectorAll('.anchors a'), function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault()
        
          let anchor = this.getAttribute('href').replace('#','')
          window.location.hash = '#'+anchor

        }, {passive: true})
      });
      
      /** Btn player */
      [].forEach.call(document.querySelectorAll('a.player'), function(el) { 
        el.addEventListener('click', function(){
          displayVideo(this.dataset.youtubeid)
        }, {passive: true})
      });

      // let sectionLine = document.querySelectorAll('.second_color')
      // if(sectionLine.length > 0){
      //   let indice = 1;
      //   [].forEach.call(document.querySelectorAll('.second_color'), function(el) {
      //     let color = el.value
      //     let span = document.createElement('span')
      //     span.textContent = indice
      //     console.log(el.nextSibling)
      //     el.nextSibling.appendChild(span)//childNode
      //     indice++
      //   })
      // }
      // let mainmenu = document.querySelectorAll('.nav-primary')
      // let menumobile = mainmenu[0].cloneNode(true)
      // menumobile.classList.add('menumobile')
      let burger = document.getElementById('menuToggle')
      burger.addEventListener('click', openCloseMenu, {passive: true});
      let closeButton = document.getElementById('closemenu')
      closeButton.addEventListener('click', closeMenu, {passive: true});

      [].forEach.call(document.querySelectorAll('.cookiesbanner button'), function(el) { 
        el.addEventListener('click', function(){
          let act = this.getAttribute('id')
          cookiesBanner.click(act)
        }, {passive: true})
      });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};

function listenerLive(event){
  var element = event.target;
  if(element.tagName == 'A' && element.classList.contains('closepopin')){
    element.closest('.thequiz').classList.remove('show--message')
    setTimeout(function(){
        let button = element.closest('.thequiz').querySelector('.nav-quiz .next')
        let step = button.offsetParent.querySelector('.nav-quiz input[type="hidden"]')
        let curstep = step.value * 1
        let slideQuiz = button.offsetParent.querySelector('ul.questions')
        let transform = 100 * curstep * -1
        slideQuiz.setAttribute('style', 'transform: translateX('+transform+'%)')
        let curslide = slideQuiz.querySelector('li:nth-child('+curstep+')')
        curslide.setAttribute('style', 'opacity: 0')

        curslide.classList.remove('current')
        let nextslide = slideQuiz.querySelector('li:nth-child('+(curstep + 1)+')')
        nextslide.setAttribute('style', 'opacity: 1')
        nextslide.classList.add('current')
        curstep++
        button.dataset.stepreached = curstep
        changeQuizStep(button,curstep);

        step.value = curstep
        let quiz = button.offsetParent.querySelector('.quiz-slider')
        if(quiz !== null){
          quiz.dataset.curstep = curstep
        }
    },400)
  }
}


function changeQuizStep(quiz, curstep){
  // console.log(quiz.closest('.quiz'))
  let theQuiz = quiz.closest('.quiz')
  let pBar = theQuiz.querySelectorAll('.progress-bar p')
  let nbStep = pBar[0].dataset.last
  pBar[0].dataset.current = curstep
  let widthBar = (curstep - 1) / nbStep
  if(widthBar == 1){
    // setTimeout(function(){
    //   [].forEach.call(theQuiz.querySelectorAll('ul.questions li:not(.end_msg)'),function(l){
    //     l.setAttribute('style', 'animation: heightZero 4s ease-in-out')
    //   })
    // },1000)
    // theQuiz.querySelector('.nav-quiz').remove()
    let buttons = theQuiz.querySelectorAll('.nav-quiz span.buttons');
    [].forEach.call(buttons,function(b){
      // b.setAttribute('style', 'transform: rotateX(360deg)')
      setTimeout(function(){
        b.setAttribute('style', 'transform: translateY(150px)')
      },0)
    })
    theQuiz.querySelector('.steps').setAttribute('style', 'opacity: 0')
  }
  pBar[0].querySelector('span').setAttribute('style', 'width: '+(widthBar * 100)+'%')
  pBar[1].querySelector('span').innerHTML = curstep
  let oTop = theQuiz.offsetTop
  let header = document.querySelector('header.banner')
  let hHeader =  header.offsetHeight
  oTop -= hHeader
  window.scroll({
    top: oTop, 
    behavior: 'smooth',
  });


}

function openCloseMenu(){
  let inputCheck = document.querySelector('#menuToggle input')
  let menunav = document.querySelectorAll('.nav-primary')
  // let wrapperSite = document.getElementById('sitecontent')
  // let wrapperInside = document.getElementById('insidecontent')
  // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

  if(inputCheck.checked){
    menunav[0].classList.add('opened')
    document.body.classList.add('opened', 'preopened')
    // wrapperSite.setAttribute('style', 'height:'+window.innerHeight+'px;')
    // wrapperInside.setAttribute('style', 'top:-'+scrollTop+'px;')
  }else{
    closeMenu()
  }
}

function resizePage(){
  let layerContent = document.querySelector('body.opened #sitecontent')
  if(layerContent != null){
    layerContent.setAttribute('style', 'height:'+window.innerHeight+'px;')
  }
}
// function offset(elt) {
//   var rect = elt.getBoundingClientRect(), bodyElt = document.body;
//   return {
//       top: rect.top + bodyElt .scrollTop,
//       left: rect.left + bodyElt .scrollLeft,
//   }
// }
function lazyLoad(){
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0

  let header = document.querySelectorAll('header.banner')
  if(scrollTop > header[0].offsetHeight){
    document.body.classList.add('scrolled')
  }else if(!document.body.classList.contains('menuopen')){
    document.body.classList.remove('scrolled')
  }

  let anchorGroup = document.querySelectorAll('.anchors_group');
  if(anchorGroup != null){
    [].forEach.call(document.querySelectorAll('section[data-anchor]'), function(el) {
      if(scrollTop + 100 >= el.offsetTop){
        let currentHash = el.dataset.anchor
        activeAnchorGroup(currentHash)
      }
    });
  }

  let windowBottom =  scrollTop + window.innerHeight;
  // console.log(windowBottom);
  [].forEach.call(document.querySelectorAll('.lazycheck'), function(el) {
    // let objectTop = el.scrollTop
    let objectTop = el.getBoundingClientRect().top + window.scrollY;
    if (objectTop <= windowBottom) {

      if(el.classList.contains('anim')){
        el.classList.add('animated');
      }

      // let keysnumbers = el.querySelectorAll('div.keynumber')
      // if(keysnumbers.length > 0 && !keysnumbers[0].classList.contains('animated')){
      //   keysnumbers[0].classList.add('animated');
      //   [].forEach.call(document.querySelectorAll('div.keynumber strong'), function(el) { 
      //     let keynumber = el.innerHTML.replace('%','')
      //     let percent = false
      //     if(!isNaN(keynumber)){
      //       if(el.innerHTML.indexOf('%') != -1){
      //         percent = true
      //         el.innerHTML = '0%';
      //       }else{
      //         el.innerHTML = '0';
      //       }
      //       let interval = 10000 / keynumber / 4;
      //       var i = 1;
      //       let timer = setInterval(function(){
      //         if(i >= keynumber){
      //           clearTimeout(timer)
      //         }
      //         el.innerHTML = (percent === true) ? i+'%' : i;
      //         i++;
      //       }, interval)
      //     }
      // });
  
      // }

      if(el.tagName.toLowerCase() == 'section' || el.classList.contains('keynumber')){
        el.classList.add('animated')
      }else if(el.tagName.toLowerCase() == 'li'){
            el.classList.add('animated')
      }else{
          let srcurl = el.dataset.src
          if(el.tagName == 'IMG' || el.tagName.toLowerCase() == 'iframe'){
              el.setAttribute('src',srcurl)
              el.classList.remove('lazycheck')
          }else if(typeof(srcurl) != 'undefined' && srcurl != ''){
              el.style.backgroundImage ='url('+srcurl+')'
              let bg = new Image()
              bg.src = srcurl
              // parallax
              if(el.classList.contains('paral')){
                let scrollTop = window.pageYOffset | document.body.scrollTop
                  if(el.offsetHeight + el.getBoundingClientRect().top > scrollTop){
                      let x = scrollTop
                      // prevents picture from coming out of its block
                      let blockWidth = el.offsetWidth
                      let ratio = blockWidth / bg.width
                      if(el.offsetHeight  + parseInt(x) < (bg.height * ratio)){
                          el.style.backgroundPosition = '0% '+parseInt(-x)+'px'
                      }
                  }
              }
          }
      }
    }
  })
}
/*
   @param time: the exact amount of time the scrolling will take (in milliseconds)
   @param pos: the y-position to scroll to (in pixels)
*/
function SmoothVerticalScrollingForSafari(pos, time) {
  var currentPos = window.pageYOffset;
  var start = null;
  if(time == null) time = 500;
  pos = +pos, time = +time;
  window.requestAnimationFrame(function step(currentTime) {
      start = !start ? currentTime : start;
      var progress = currentTime - start;
      if (currentPos < pos) {
          window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
      } else {
          window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
      }
      if (progress < time) {
          window.requestAnimationFrame(step);
      } else {
          window.scrollTo(0, pos);
      }
  });
}
// function SmoothVerticalScrolling(e, time, where) {
//   var eTop = e.getBoundingClientRect().top;
//   let eAmt = eTop / 100;
//   let curTime = 0;
//   while (curTime <= time) {
//       window.setTimeout(SVS_B, curTime, eAmt, where);
//       curTime += time / 100;
//       console.log(eTop+ ' --> '+eAmt)

//   }
// }

// function SVS_B(eAmt, where) {
//   if(where == 'center' || where == '')
//       window.scrollBy(0, eAmt / 2);
//   if (where == 'top')
//       window.scrollBy(0, eAmt);
// }

function loadVideo(videoID){
  let close = document.createElement('A')
  close.classList.add('close')
  close.setAttribute('href','javascript:void(0)')
  close.innerHTML = 'Fermer'

  let bg = document.createElement('DIV')
  bg.classList.add('store')

  let aroundFrame = document.createElement('DIV')
  aroundFrame.classList.add('around')

  let frame = document.createElement('DIV')
  frame.classList.add('frame')

  let iframe = document.createElement('IFRAME')
  iframe.setAttribute('src', 'https://www.youtube.com/embed/'+videoID+'?autoplay=1&showinfo=0&rel=0')
  iframe.setAttribute('autoplay', 'autoplay')
  iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')


  aroundFrame.appendChild(frame)
  frame.appendChild(close)
  frame.appendChild(iframe)
  bg.appendChild(aroundFrame)

  document.body.appendChild(bg)
  bg.addEventListener('click', function(){
    document.body.removeChild(bg)
  }, {passive: true})
}

function loadPortrait(member){
  // function(event, delta) {
  //   this.scrollTop -= (delta * 30);
  //   event.preventDefault();
  // }
  var xMousePos = 0;
  var yMousePos = 0;
  let layerPortrait = document.querySelector('.portrait')
  let closeCard = document.getElementById('closecard')
  let h4 = document.querySelector('.portrait h4')
  let photo = document.querySelector('.portrait .photo')
  let presentationBlock = document.querySelector('.portrait .presentation .nth1')
  let socialBlock = document.querySelector('.portrait .presentation .nth2')

  let socialNetwork = ''
  if(typeof(member.dataset.photo) != 'undefined'){
    photo.style.backgroundImage = 'url('+member.dataset.photo+')'
  }else if(typeof(member.dataset.bgcolor) != 'undefined'){
    photo.style.background = member.dataset.bgcolor
  }
  if(typeof(member.dataset.network) != 'undefined'){
    let jsonSocialNetwork = JSON.parse(member.dataset.network)
    for(var i in jsonSocialNetwork){
      socialNetwork += '<a href="'+jsonSocialNetwork[i]['__url']+'" target="_blank">'+jsonSocialNetwork[i]['__name']+'</a> '
    }
  }

  // console.log(member.childNodes[1].childNodes[1].textContent)
  let presentation = member.childNodes[1].childNodes[5].innerHTML

  h4.innerHTML = member.dataset.name
  h4.nextElementSibling.innerHTML = member.dataset.fonction

  presentationBlock.innerHTML = presentation
  socialBlock.innerHTML = socialNetwork

  layerPortrait.classList.add('visible')
  layerPortrait.addEventListener('mousemove', function(e){
    xMousePos = e.clientX + window.pageXOffset - 50;
    yMousePos = e.clientY - 50;
    closeCard.setAttribute('style', 'opacity: 1; transform: translateX('+xMousePos+'px) translateY('+yMousePos+'px);')
  })
  socialBlock.addEventListener('mouseover', function(){
    closeCard.classList.add('hide')
  })
  socialBlock.addEventListener('mouseout', function(){
    closeCard.classList.remove('hide')
  });
  // [].forEach.call(document.querySelectorAll('.portrait .presentation .nth2 a'), function(el){
  //   el.addEventListener('click', function(e){
  //     e.preventDefault()
  //   })
  // })


}

function reloadFormations(filters){
  // console.log(filters)
  let ajax = new XMLHttpRequest()
  ajax.onload = displayFormations
  ajax.open('post', window.ajaxurl, true)
  let datas = new FormData()
  datas.append('action', 'filter_formation')
  datas.append('filters', filters)
  ajax.send(datas)
}
function displayFormations(){
  let answer = JSON.parse(this.responseText)
  let container = document.querySelector('div.formations')
  // let animSvg = container.querySelectorAll('.anim--svg');

  let blocContainers = container.querySelectorAll('ul.flex');
  // console.log('Nombre d\'UL : '+blocContainers.length);
  [].forEach.call(blocContainers, function(el){
    el.innerHTML = ''
  })


  // container.innerHTML = ''

  let newContent = ''
  let i = 0
  let j = 0
  for(var formation in answer.formations){
    let ulContainer  = blocContainers[j]
    
    if(i%9 == 0 && i > 0){
      ulContainer.innerHTML = newContent
      newContent = ''     
      j++
    }

    newContent += `<li class="lazycheck">
                    <div>
                        <a href="${answer.formations[formation].url}">
                            <img src="" alr="${answer.formations[formation].title}" data-src="${answer.formations[formation].picture}" class="lazycheck" />
                        </a>
                    </div>
                    <div class="infos">
                        <a href="${answer.formations[formation].url}">
                            <h5>${answer.formations[formation].title}<em style="background-color: ${answer.formations[formation].color};"></em></h5>
                            <span>${answer.formations[formation].excerpt}</span> 
                        </a>                             
                    </div>
                    
                </li>`;
    if((i == answer.formations.length - 1 && i%9 !=0) || (answer.formations.length == 1)){
      ulContainer.innerHTML = newContent
    }
    i++
  }
  let oTop = document.querySelector('.thematiques').offsetParent.offsetTop + 70
  SmoothVerticalScrollingForSafari(oTop, 500)

  // window.scroll({
  //   top: oTop, 
  //   behavior: 'smooth',
  // });
  window.dispatchEvent(new Event('resize'))

  lazyLoad()
}

function sendForm(){

  let error = 0 
  let answer = document.getElementById('answer')
  let parentForm = document.querySelector('.custom--list')
  let oParent = document.querySelectorAll('div.contact--form')
  answer.classList.remove('visible')

  let inputs  = document.querySelectorAll('.contact--form input[type="text"], .contact--form textarea');
  [].forEach.call(inputs, function(el){
    if(el.value == '' && !el.classList.contains('optional')){
     el.offsetParent.classList.add('error')
      error = 1
    }
  })

  let acceptcond = document.getElementById('acceptcond')
  if(acceptcond.checked === false){
    acceptcond.offsetParent.classList.add('error')
    error = 1
  }

  if(error == 1){
      answer.classList.add('visible')
      let sTop = oParent[0].offsetTop - 135 + parentForm.offsetTop
      SmoothVerticalScrollingForSafari(sTop, 500)
      return false
  }
  sendAjaxForm()
}

function sendAjaxForm(){
  let ajax = new XMLHttpRequest()
  ajax.onload = displayAnswerContact
  ajax.open('post', window.ajaxurl, true)
  let datas = new FormData()
  datas.append('action', 'contact_form')
  datas.append('company',document.getElementById('company').value)
  datas.append('lastname', document.getElementById('lastname').value)
  datas.append('contactmail', document.getElementById('contactmail').value)
  datas.append('contactmsg', document.getElementById('contactmsg').value)
  ajax.send(datas)
}
function displayAnswerContact(){
  let answer = JSON.parse(this.responseText)
  let answerBlock = document.getElementById('answer')
  let parentForm = document.querySelector('.contact--form')
  let oParent = document.querySelectorAll('div[class*="contact--form__"]')
  let sTop = oParent[0].offsetTop - 135 + parentForm.offsetTop

  if(answer && answer.errors){
    answerBlock.classList.add('visible')
    for(var element in answer.errors){
      document.getElementById(answer.errors[element]).offsetParent.classList.add('error')
    }
  }else if(answer && answer.message){
    answerBlock.classList.add('visible', 'ok')
    answerBlock.classList.remove('error')
    oParent[0].classList.add('flex-start');
    [].forEach.call(document.querySelectorAll('#form span.line, #form div.line'), function(el){
      el.remove()
    })
    answerBlock.innerHTML = answer.message
  }else{
    answerBlock.innerHTML = 'Une erreur est survenue, merci de réessayer ultérieurement'
    answerBlock.classList.remove('ok')
    answerBlock.classList.add('visible', 'error')
  }
  
  SmoothVerticalScrollingForSafari(sTop, 500)
  // let container = document.getElementById('answer')
}

function sendEbookForm(){
  let error = 0
  let answer = document.getElementById('__answer')
  let parentForm = document.querySelector('.eform')
  let oParent = document.querySelectorAll('section.section--ebook')
  answer.classList.remove('visible')

  let inputs  = document.querySelectorAll('.section--ebook input[type="text"], .section--ebook input[type="email"], .section--ebook textarea');
  [].forEach.call(inputs, function(el){
    if(el.value == '' && !el.classList.contains('optional')){
     el.offsetParent.classList.add('error')
      error = 1
    }
  })

  let acceptcond = document.getElementById('__acceptcond')
  if(acceptcond.checked === false){
    acceptcond.offsetParent.classList.add('error')
    error = 1
  }

  if(error == 1){
      answer.classList.add('visible')
      let sTop = oParent[0].offsetTop - 135 + parentForm.offsetTop
      SmoothVerticalScrollingForSafari(sTop, 500)
      return false
  }
  sendAjaxEbookForm()
}

function sendAjaxEbookForm(){
  let ajax = new XMLHttpRequest()
  ajax.onload = displayAnswerEbookFrom
  ajax.open('post', window.ajaxurl, true)
  let datas = new FormData()
  datas.append('action', 'ebook_form')
  // datas.append('firstname',document.getElementById('firstname').value)
  datas.append('lastname', document.getElementById('eb_lastname').value)
  datas.append('firstname', document.getElementById('eb_firstname').value)
  datas.append('emailform', document.getElementById('eb_emailform').value)
  datas.append('postid', document.getElementById('postid').value)
  datas.append('document', document.getElementById('document').value)
  // datas.append('phonenumber', document.getElementById('phonenumber').value)
  // datas.append('company', document.getElementById('company').value)
  // datas.append('website', document.getElementById('website').value)
  ajax.send(datas)
}
function displayAnswerEbookFrom(){
  let answer = JSON.parse(this.responseText)
  let answerBlock = document.getElementById('__answer')
  let parentForm = document.querySelector('.eform')
  let oParent = document.querySelectorAll('section.section--ebook')
  let sTop = oParent[0].offsetTop - 135 + parentForm.offsetTop

  if(answer && answer.errors){
    for(var element in answer.errors){
      let el = document.getElementById(answer.errors[element])
      if(el != null){
        el.offsetParent.classList.add('error')
        answerBlock.innerHTML = answer.message
        console.log(answer.message)
      }else{
        answerBlock.innerHTML = answer.message
      }
    }
    answerBlock.classList.remove('ok')
    answerBlock.classList.add('visible', 'error')
  }else if(answer && answer.message){
    answerBlock.classList.add('visible', 'ok')
    answerBlock.classList.remove('error');
    [].forEach.call(document.querySelectorAll('.eform span, .ebook .text'), function(el){
      el.remove()
    })
    parentForm.classList.add('ok')

    answerBlock.innerHTML = answer.message
  }else{
    answerBlock.innerHTML = 'Une erreur est survenue, merci de réessayer ultérieurement'
    answerBlock.classList.remove('ok')
    answerBlock.classList.add('visible', 'error')
  }
  SmoothVerticalScrollingForSafari(sTop, 500)
  // let container = document.getElementById('answer')
}


function activeAnchorGroup(hash){
  let anchorGroup = document.querySelectorAll('.anchors_group');
  if(anchorGroup == null || anchorGroup.length == 0){
    return false
  }

  [].forEach.call(document.querySelectorAll('.anchors_group a'), function(el) {
    el.classList.remove('active')
  });
  if(hash != ''){
    let anchor = document.querySelectorAll('.anchors_group a[href="#'+hash+'"]')
    anchor[0].classList.add('active');
  }else{
    let anchor = document.querySelectorAll('.anchors_group a')
    anchor[0].classList.add('active');
  }
}

function activeCurrentTab(hash, scrollToTab = false){
  let tabs = document.getElementById('tabs'); 
  if(tabs == null){
    console.log('fr')

    activeAnchorGroup(hash)
    return false
  }

  /** Active sub-menu entry */
  [].forEach.call(document.querySelectorAll('.current-menu-ancestor .sub-menu li a'), function(el) {
    if(el.getAttribute('href').match(hash)){
      el.parentNode.classList.add('current_page_item')
    }else{
      el.parentNode.classList.remove('current_page_item')
    }
  })

  /** Active current option in select nav  */
  document.querySelector('#select--onglet [data-name="' + hash + '"]').selected = true;

  /** Adjust tabs scroll page */
  if(scrollToTab === true){
    let oTop = tabs.offsetTop
    window.scroll({
      top: oTop, 
      behavior: 'smooth',
    });
  }

  /** Active current tab  */
  [].forEach.call(document.querySelectorAll('.nav--tab .left--column a'), function(el) {

    let indexTab = el.dataset.index
    let tab = document.getElementById('tab_'+indexTab);

    if(el.dataset.slug == hash)
    {
      el.classList.add('active')
      tab.classList.add('active')
    }
    else
    {
      el.classList.remove('active')
      tab.classList.remove('active')
    }
  })
}

function displayVideo(videoID){
  let close = document.createElement('A')
  close.classList.add('close')
  close.setAttribute('href','javascript:void(0)')
  close.innerHTML = 'Fermer'

  let bg = document.createElement('DIV')
  bg.classList.add('store')

  let aroundFrame = document.createElement('DIV')
  aroundFrame.classList.add('around')

  let frame = document.createElement('DIV')
  frame.classList.add('frame')

  let iframe = document.createElement('IFRAME')
  iframe.setAttribute('src', 'https://www.youtube.com/embed/'+videoID+'?autoplay=1')
  iframe.setAttribute('autoplay', 'autoplay')
  iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')


  aroundFrame.appendChild(frame)
  frame.appendChild(close)
  frame.appendChild(iframe)
  bg.appendChild(aroundFrame)

  document.body.appendChild(bg)
  bg.addEventListener('click', function(){
    document.body.removeChild(bg)
  }, {passive: true})
}

function closeMenu(){
  let inputCheck = document.querySelector('#menuToggle input')
  let menunav = document.querySelectorAll('.nav-primary')
  let wrapperSite = document.getElementById('sitecontent')
  let wrapperInside = document.getElementById('insidecontent')

  inputCheck.checked = false
  menunav[0].classList.remove('opened')
  document.body.classList.remove('opened')
  // let scrollTo = (wrapperInside.style.top.replace('px','') * -1)

  setTimeout(function(){
    document.body.classList.remove('preopened')
  },250)
  setTimeout(function(){
    wrapperInside.setAttribute('style', 'top:auto;')
    wrapperSite.setAttribute('style', 'height:auto;')
  },250)
  // setTimeout(function(){
  //   window.scrollTo(0,scrollTo)
  // },550)

}

let cookiesBanner = {
  cookiesbanner : true,
  init(){
      this.cookiesbanner = this.getCookie('cookiesbanner');
      if(!this.cookiesbanner)
      {
          let banner = document.querySelectorAll('.cookiesbanner');
          banner[0].classList.add('block');
      }
          
      this.checkConsent();
  },
  click(action){
      this.setCookie('cookiesbanner',action);
      this.cookiesbanner = action;
      let cookban = document.querySelectorAll('.cookiesbanner')
      cookban[0].remove()

      this.checkConsent();
  },
  checkConsent(){
      if (this.cookiesbanner=='accept'){ 
          window.dataLayer = window.dataLayer || [];
          gtag('js', new Date()); 
          gtag('config', window.gaTrackerIG);

          // (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
          // (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
          // m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
          // })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

          // ga('create', 'UA-104717718-3', 'auto');
          // ga('set', 'dimension1', 'guest');
          // ga('send', 'pageview');

      }
  },
  getCookie(name){
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? decodeURIComponent(v[2]) : null;
  },
  setCookie(name, value, days=183) {
      var d = new Date;
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + d.toGMTString();
  },
}
if(window.gaTrackerIG){
  cookiesBanner.init()
}
function gtag(){window.dataLayer.push(arguments);}


if(document.querySelector('#menumobile .page-item-1853 a') != null){
  document.querySelector('#menumobile .page-item-1853 a').href='#!'; 
}



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js